(function () {
  var downloadIcon =
    '<svg class="icon icon-download" width="28" height="28" viewBox="0 0 28 28" fill="none" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M9.19993 26H18.7998C22.1939 26 23.8909 26 24.9453 24.9456C25.9998 23.8913 25.9998 22.1941 25.9998 18.8001V17.6001C25.9998 14.206 25.9998 12.509 24.9453 11.4546C24.0233 10.5325 22.6098 10.4168 19.9998 10.4023M7.99994 10.4023C5.38993 10.4168 3.97645 10.5325 3.05441 11.4546C2 12.509 2 14.206 2 17.6001V18.8001C2 22.1941 2 23.8913 3.05441 24.9456C3.41416 25.3053 3.84873 25.5423 4.39998 25.6986" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
    '<path d="M13.9999 2V17.5998M13.9999 17.5998L10.3999 13.3999M13.9999 17.5998L17.5998 13.3999" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  function updateDownloadsPanel(listEl, variantId) {
    var dataEl = document.getElementById(
      'VariantDownloads-' + listEl.dataset.downloadsPanel,
    );
    if (!dataEl) return;

    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    renderList(listEl, data[variantId] || []);
  }

  function renderList(listEl, docs) {
    if (!docs || docs.length === 0) {
      var emptyText = listEl.dataset.emptyText || 'No downloads available.';
      listEl.innerHTML =
        '<li class="product-downloads-empty">' + escapeHtml(emptyText) + '</li>';
      return;
    }

    listEl.innerHTML = docs
      .map(function (doc) {
        var label = doc.HyperlinkText || doc.Description || 'Download';
        var url = doc.URL || '#';
        return (
          '<li class="product-downloads-item">' +
          '<a class="product-downloads-link" href="' +
          escapeAttr(String(url)) +
          '" target="_blank" rel="noopener">' +
          downloadIcon +
          '<span class="product-downloads-text">' +
          escapeHtml(String(label)) +
          '</span>' +
          '</a>' +
          '</li>'
        );
      })
      .join('');
  }

  function escapeHtml(str) {
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function escapeAttr(str) {
    return escapeHtml(str).replace(/'/g, '&#39;');
  }

  webvista.subscribe('variant-change', function (event) {
    var variant = event.data && event.data.variant;
    if (!variant) return;

    document.querySelectorAll('[data-downloads-panel]').forEach(function (listEl) {
      updateDownloadsPanel(listEl, String(variant.id));
    });
  });
})();
